import { render, staticRenderFns } from "./SelfIntroduction.vue?vue&type=template&id=51eb6b6c&scoped=true"
import script from "./SelfIntroduction.vue?vue&type=script&lang=js"
export * from "./SelfIntroduction.vue?vue&type=script&lang=js"
import style0 from "./SelfIntroduction.vue?vue&type=style&index=0&id=51eb6b6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51eb6b6c",
  null
  
)

export default component.exports